import RaikoBaseContainer from "../../raikoComponents/raikoBaseContainer/RaikoBaseContainer";
import RaikoGridOneColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridOneColumn";
import {css} from "@emotion/css";
import RaikoBreadcrumb, {
    raikoBreadCrumbItemGenerator
} from "../../raikoComponents/raikoBreadcrumbCustom/RaikoBreadcrumb";
import RaikoBaseCardContainer from "../../raikoComponents/raikoBaseCardContainer/RaikoBaseCardContainer";
import {
    prepareDoughnutChartDatasetItem,
    RaikoDoughnutChart
} from "../../raikoComponents/raikoDoughnutChart/RaikoDoughnutChart";
import RaikoGridTwoColumn from "../../raikoComponents/raikoCustomGrids/RaikoGridTwoColumn";
import {useState} from "react";
import {chartBackgroundColor} from "../../raikoComponents/raikoDoughnutChart/RaikoChartUtils";

export const ChartSample = () => {

    const [donatChartLabels, setDonatChartLabels] = useState([
        "کل درخواست ها",
        "پذیرفته شده",
        "لغو شده",
        "رد شده",
    ]);

    const [donatChartDataSet, setDonatChartDataSet] = useState([
        prepareDoughnutChartDatasetItem(
            ["درخواست ها","در حال بررسی","پذیرفته شده","رد شده"],
            [35,15,15,5],
            [chartBackgroundColor.Blue,chartBackgroundColor.Yellow,chartBackgroundColor.Green,chartBackgroundColor.Purple],
            [chartBackgroundColor.Blue,chartBackgroundColor.Yellow,chartBackgroundColor.Green,chartBackgroundColor.Purple],
        )
    ]);


    return (
        <>
            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator("نمودار ها", ""),
                        raikoBreadCrumbItemGenerator("نمودار های پیشفرض", ""),
                    ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridTwoColumn>
                            <RaikoDoughnutChart labels={donatChartLabels} datasets={donatChartDataSet}/>
                        </RaikoGridTwoColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>
        </>
    )
}